import { map, type MapStore } from 'nanostores';

export type ChatStatus = 'ready' | 'submitted' | 'streaming' | 'error' | 'importing' | 'fixing-errors';

export interface ChatStateValue {
  status: ChatStatus;
}

export const chatState: MapStore<ChatStateValue> = map<ChatStateValue>({
  status: 'ready',
});

// --- Mutators ---
export function setStatus(status: ChatStatus): void {
  const current = chatState.get();
  chatState.set({ status });
}

export function resetChatState(): void {
  chatState.set({
    status: 'ready',
  });
}

// Convenience getter
export function getChatState(): ChatStateValue {
  return chatState.get();
}
